import { Routes } from '@angular/router';

/** Páginas públicas del SSO (fuera del armazón autenticado). */
export const authRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
    title: 'SiLabVet | Iniciar sesión',
  },
  {
    path: 'callback',
    loadComponent: () => import('./pages/callback/callback.page').then((m) => m.CallbackPage),
    title: 'SiLabVet | Validando sesión',
  },
];
